import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AccessTokenService } from './access-token.service';
import { X_CHANNEL } from '../constants/x-channel.constant';

@Injectable({
  providedIn: 'root'
})
export class AjaxService {
  private notAuthHeaders = {
    'Content-Type': 'application/json; charset=UTF-8',
    'x-canal': X_CHANNEL
  };
  private authHeaders = {
    ...this.notAuthHeaders,
    Authorization: `Bearer ${this.accessTokenService.accessToken}`
  };

  constructor(private accessTokenService: AccessTokenService, private httpClient: HttpClient) {}

  public async get<T>(url: string, notAuth = false, customHeaders: any = {}, returnType = 'body') {
    const headers = notAuth
      ? {
          ...this.notAuthHeaders,
          ...customHeaders
        }
      : {
          ...this.authHeaders,
          ...customHeaders
        };

    return lastValueFrom(this.httpClient.get<T>(url, { headers, observe: returnType as 'body' }));
  }

  public async post<T>(url: string, body: any = {}, notAuth = false, customHeaders: any = {}, returnType = 'body') {
    const headers = notAuth
      ? {
          ...this.notAuthHeaders,
          ...customHeaders
        }
      : {
          ...this.authHeaders,
          ...customHeaders
        };

    return lastValueFrom(this.httpClient.post<T>(url, body, { headers, observe: returnType as 'body' }));
  }

  public async put<T>(url: string, body: any = {}, customHeaders: any = {}) {
    const options = {
      headers: {
        ...this.authHeaders,
        ...customHeaders
      }
    };

    return lastValueFrom(this.httpClient.put<T>(url, body, options));
  }

  public async delete<T>(url: string, customHeaders: any = {}) {
    const options = {
      headers: {
        ...this.authHeaders,
        ...customHeaders
      }
    };

    return lastValueFrom(this.httpClient.delete<T>(url, options));
  }

  public async postForm<T>(url: string, params: { [param: string]: any } = {}) {
    const options = {};

    const body = new FormData();

    for (const paramName of Object.keys(params)) {
      body.set(paramName, params[paramName]);
    }

    return lastValueFrom(this.httpClient.post<T>(url, body, options));
  }

  public async downloadFile(url: string) {
    const options = {
      responseType: 'blob' as const
    };

    return lastValueFrom(this.httpClient.get(url, options));
  }

  public fetchAsBlob = (url: string) => fetch(url).then((response) => response.blob());

  // TODO: (Futuramente) Remover quando nao houver mais mocks
  public getJSON<T>(url: string, params: { [param: string]: string | string[] } = {}) {
    const options = {
      params: params,
      headers: this.notAuthHeaders
    };

    url = `./assets/mock${url}.json`;

    return lastValueFrom(this.httpClient.get<T>(url, options));
  }
}
